import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly http = inject(HttpClient);
  private readonly errorHandler = inject(ErrorHandlerService);

  readonly loading = signal(false);
  readonly data = signal<unknown[]>([]);

  async fetchData(): Promise<void> {
    this.loading.set(true);
    try {
      const result = await this.http.get<unknown[]>('/api/analytics').toPromise();
      this.data.set(result ?? []);
    } catch (error) {
      this.errorHandler.handle(error, 'AnalyticsService.fetchData');
    } finally {
      this.loading.set(false);
    }
  }
}
